// {
//   "id": 688,
//   "audiences": [
//       {
//           "i": 1,
//           "t": 81,
//           "a": "8a1bf5f6d1e14df9ab3f564428f4355b",
//           "g": null,
//           "aN": "duc",
//           "aE": "👜",
//           "color": "rgba(78, 170, 241, 1)",
//           "oldPercent": 100,
//           "active": true
//       },
//       {
//           "i": 2,
//           "t": 0,
//           "a": "8d6ae1ae330d466d8ebc462dda2eee76",
//           "g": null,
//           "aN": "duc2",
//           "aE": "👳",
//           "color": "rgba(255, 175, 9, 1)",
//           "oldPercent": 1
//       }
//   ],
//   "teams": [],
//   "totalQuiz": 1,
//   "currentQuiz": 1,
//   "lastSlide": true
// }

export const getTotalCount = (leaderboardData, type = 'audiences') => {
  return leaderboardData[type].length
}

export const getRankingById = (leaderboardData, id, type = 'audiences') => {
  if (!id) {
    throw new Error('id is required')
  }
  const idAttribute = type === 'audiences' ? 'a' : 'id'
  const audienceOrTeam = leaderboardData[type].find((obj) => obj[idAttribute] === id)
  if (!audienceOrTeam) { // handle case audience or team not exist on leaderboard
    return {
      ranking: -1,
      percentile: 0,
    }
  }
  const ranking = audienceOrTeam.i
  const count = getTotalCount(leaderboardData, type)
  return {
    ranking: audienceOrTeam.i,
    // percentile = 0.95 meaning your score is better than 95% of all audiences
    // assuming ranking (i) starts from 1
    percentile: (count - ranking) / count,
  }
}

// {
//   "id": 690,
//   "audiences": [
//       {
//           "i": 1,
//           "t": 87,
//           "a": "88b3c8fb06b74d78956c70261e7cc6ea",
//           "g": 1,
//           "aN": "duc team 1",
//           "aE": "😷"
//       },
//       {
//           "i": 2,
//           "t": 0,
//           "a": "43c1da442e4f4230a8cbca1bd2b82334",
//           "g": 2,
//           "aN": "duc team 2",
//           "aE": "👨‍👩‍👧"
//       }
//   ],
//   "teams": [
//       {
//           "i": 1,
//           "t": 87,
//           "a": "Team 1",
//           "id": 1,
//           "color": "rgba(255, 175, 9, 1)",
//           "members": [
//               {
//                   "i": 1,
//                   "t": 87,
//                   "a": "88b3c8fb06b74d78956c70261e7cc6ea",
//                   "g": 1,
//                   "aN": "duc team 1",
//                   "aE": "😷"
//               }
//           ],
//           "oldPercent": 100,
//           "active": true
//       },
//       {
//           "i": 2,
//           "t": 0,
//           "a": "Team 2",
//           "id": 2,
//           "color": "rgba(40, 194, 112, 1)",
//           "members": [
//               {
//                   "i": 2,
//                   "t": 0,
//                   "a": "43c1da442e4f4230a8cbca1bd2b82334",
//                   "g": 2,
//                   "aN": "duc team 2",
//                   "aE": "👨‍👩‍👧"
//               }
//           ],
//           "oldPercent": 1
//       }
//   ],
//   "totalQuiz": 1,
//   "currentQuiz": 1,
//   "lastSlide": true
// }
export const getTeamCount = (leaderboardData) => {
  return getTotalCount(leaderboardData, 'teams')
}

export const getRankingByTeamId = (leaderboardData, teamId) => {
  if (!teamId) {
    throw new Error('teamId is required')
  }
  return getRankingById(leaderboardData, teamId, 'teams')
}

export const getTeamMemberRankingWithinATeamByTeamIdAndAudienceId = (
  leaderboardData,
  teamId,
  audienceId,
) => {
  if (!teamId || !audienceId) {
    throw new Error('teamId and audienceId are required')
  }
  if (!leaderboardData.teams) {
    throw new Error('team data does not exist')
  }

  const team = leaderboardData.teams.find((t) => t.id === teamId)
  if (!team) { // handle case team not exist on leaderboard
    return {
      ranking: -1,
      percentile: 0,
    }
  }
  const teamMembersSortedByIndividualRanking = [...team.members].sort((a, b) => {
    return a.i - b.i
  })
  const teamMembersRankingSortedByIndividualRankingIndexedByAudienceId = {}
  teamMembersSortedByIndividualRanking.forEach((m, index) => {
    teamMembersRankingSortedByIndividualRankingIndexedByAudienceId[m.a] = index + 1
  })
  const leaderboardDataWithinATeam = {
    audiences: team.members.map((au) => {
      return {
        ...au,
        i: teamMembersRankingSortedByIndividualRankingIndexedByAudienceId[au.a],
      }
    }),
  }
  return getRankingById(leaderboardDataWithinATeam, audienceId)
}

const contentTemplate = (
  numberOfQuestions,
  correctRate,
  isTeam,
  self,
) => {
  if (isTeam) {
    return `<p class="mt-0">${self.$t('outOfQuestionsYourTeam',
      {
        number: numberOfQuestions || 0,
      })} ${self.$t('gotCorrectRate', {
      number: `<strong>${correctRate || 0}%</strong>`,
    })}.</p>`
  }
  return `<p class="mt-0">${self.$t('outOfQuestionsYou',
    {
      number: numberOfQuestions || 0,
    })} ${self.$t('gotCorrectRate', {
    number: `<strong>${correctRate || 0}%</strong>`,
  })}.</p>`
}

export const getQuizBragCorrectRateTextContent = (numberOfQuestions, correctRate, isTeam, self) => {
  if (!correctRate) correctRate = 0

  const res = {
    title: '',
    emoji: '',
    content: '',
  }
  if (correctRate >= 90) {
    res.title = self.$t('wow')
  } else if (correctRate >= 70) {
    res.title = self.$t('whatAPerformance')
  } else if (correctRate >= 50) {
    res.title = self.$t('nicelyDone')
  } else {
    res.title = self.$t('toughQuizRight')
    res.emoji = '😢'
  }
  res.content = contentTemplate(numberOfQuestions, correctRate, isTeam, self)
  return res
}
